// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arc-bottom-middle {
  width: 15%;
  height: 15%;
  z-index: 9999;
  left: 50%; /* Default for md screens */
  transform: translateX(-50%);
}
@media (min-width: 992px) {
  .arc-bottom-middle { /* lg and up */
    left: 66.666%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/layouts/user-management-layout/user-management-layout.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA,EAAA,2BAAA;EACA,2BAAA;AACF;AACE;EAPF,qBAO8B,cAAA;IAC1B,aAAA;EAEF;AACF","sourcesContent":[".arc-bottom-middle {\n  width: 15%;\n  height: 15%;\n  z-index: 9999;\n  left: 50%; /* Default for md screens */\n  transform: translateX(-50%);\n\n  @media (min-width: 992px) { /* lg and up */\n    left: 66.666%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
